/**
 * Web端菜单配置
 * 包含Web管理后台的所有菜单项
 */
import { webMenuTree } from "./web-menu-tree";

/**
 * 从树形菜单配置生成 WEB_MENU_IDS
 * @param {Array} nodes - 树形菜单节点
 * @returns {Record<string, number>}
 */
function buildWebMenuIds(nodes) {
  const ids = {};

  const walk = (items) => {
    items.forEach((node) => {
      if (node.key) {
        ids[node.key] = node.id;
      }

      if (node.children && node.children.length > 0) {
        walk(node.children);
      }
    });
  };

  walk(nodes);
  return ids;
}

/**
 * Web端菜单ID常量（由 web-menu-tree 自动生成）
 * 用于外部权限判断
 */
export const WEB_MENU_IDS = buildWebMenuIds(webMenuTree);

// Web端菜单树（AddRoleDialog 等权限树使用）
export { webMenuTree };
